import Accordion from "./custom-component/Accordion";
import TechStackGroup from "./TechStackGroup";

const AIComponent = ({ siteTheme, isDay, aiTechStacks, aiData }) => {
  return (
    <div className="font-saira flex flex-col items-center justify-center w-full mx-auto px-2 md:px-5 lg:px-0 max-w-max-profile-content-width text-neutral-400 mb-20 md:mb-32">
      <div className="relative flex flex-row items-center w-ful mb-10 w-full">
        <div className="mr-2 flex-[0.5] h-[1px] bg-gradient-to-r from-transparent to-linesLight" />
        <p
          className={`${siteTheme.textColor} flex-[1] text-lg sm:text-2xl text-center font-semibold uppercase w-fit`}
        >
          Artificial Intelligence
        </p>
        <div className="ml-2 flex-[0.5] h-[1px] bg-gradient-to-r from-linesLight to-transparent" />
      </div>
      <div className="">
        <div className="relative flex items-center justify-start w-full md:w-[50%] mb-3">
          <div className="w-fit">
            <p
              className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
            >
              Summary
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center w-full px-0 md:px-5 mx-auto max-w-max-profile-content-width lg:px-0">
          <TechStackGroup
            data={aiTechStacks}
            widthAndheight="w-10 h-10"
            gap="gap-2 lg:gap-4"
            isLong={true}
            classname="!justify-start w-full lg:ml-10"
          />
        </div>
        <div className="mt-1 ml-0 md:ml-10">
          <p
            className={`${
              isDay ? siteTheme.textColor : "text-neutral-400"
            } font-light text-[14px] tracking-[0.08em] leading-loose font-saira`}
          >
            {aiData?.summary}
          </p>
        </div>
        <div className="relative flex items-center justify-start w-full md:w-[50%] mt-3">
          <div className="w-fit">
            <p
              className={`${siteTheme.textColor} text-[10px] tracking-[0.1em] uppercase font-semibold font-saira`}
            >
              AI - Projects
            </p>
          </div>
        </div>
        <div className="mt-1 ml-0 md:ml-10">
          {aiData?.aiStack?.map((stack, index) => (
            <Accordion
              key={index}
              data={stack}
              siteTheme={siteTheme}
              isDay={isDay}
              isSingleText={true}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIComponent;
